import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('negociacao', 'contrato');

const contratoLojaActions = {
  vincular: { method: 'PUT', url: `${basePath}/{codigoContrato}/loja` },
  pesquisar: { method: 'GET', url: `${basePath}/{codigoContrato}/loja` },
};

export default resource => resource(`${basePath}`, {}, contratoLojaActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/contrato-loja.js